export default __webpack_public_path__ + "static/media/img-about.863a42db.jpg";